import * as React from 'react';

function SvgMyTeamsTab(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>{/* <style>{`.my_teams_tab_svg__prefix__cls-2{fill:${props.fill}`}</style> */}</defs>
      <g id="my_teams_tab_svg__prefix__my_teams" transform="translate(-314 -768)">
        <path
          id="my_teams_tab_svg__prefix__Bounds"
          d="M0 0h24v24H0z"
          transform="translate(314 768)"
          fill="none"
        />
        <g id="my_teams_tab_svg__prefix__team" transform="translate(315 756.407)">
          <g id="my_teams_tab_svg__prefix__group-71svg" transform="translate(0 15.593)">
            <path
              id="my_teams_tab_svg__prefix__path-1_67_"
              d="M27.241 44.474a.527.527 0 01-.527-.527 6.107 6.107 0 00-12.213 0 .527.527 0 11-1.055 0 7.161 7.161 0 0114.323 0 .527.527 0 01-.528.527z"
              className="my_teams_tab_svg__prefix__cls-2"
              transform="translate(-8.719 -29.336)"
            />
            <path
              id="my_teams_tab_svg__prefix__path-2_67_"
              d="M26.155 23.9a4.154 4.154 0 114.154-4.154 4.159 4.159 0 01-4.154 4.154zm0-7.253a3.1 3.1 0 103.1 3.1 3.1 3.1 0 00-3.1-3.099z"
              className="my_teams_tab_svg__prefix__cls-2"
              transform="translate(-14.267 -15.593)"
            />
            <path
              id="my_teams_tab_svg__prefix__path-3_55_"
              d="M4.586 42.446H.527A.527.527 0 010 41.918a5.845 5.845 0 015.985-5.967 6.062 6.062 0 013.061.856.527.527 0 11-.528.913 5.024 5.024 0 00-2.533-.714 4.8 4.8 0 00-4.9 4.385h3.501a.527.527 0 110 1.055z"
              className="my_teams_tab_svg__prefix__cls-2"
              transform="translate(0 -28.794)"
            />
            <path
              id="my_teams_tab_svg__prefix__path-4_34_"
              d="M10.593 25.641a3.524 3.524 0 112.492-6.016.527.527 0 01-.746.746 2.469 2.469 0 10.285 3.151.527.527 0 11.867.6 3.527 3.527 0 01-2.898 1.519z"
              className="my_teams_tab_svg__prefix__cls-2"
              transform="translate(-4.584 -17.538)"
            />
            <path
              id="my_teams_tab_svg__prefix__path-5_17_"
              d="M49.615 31.48h-2.826a.527.527 0 010-1.055h2.27a4.945 4.945 0 00-4.425-4.341.527.527 0 01-.048-1.041 2.438 2.438 0 002-2.394 2.675 2.675 0 00-2.661-2.549.527.527 0 010-1.055 3.758 3.758 0 013.712 3.609 3.451 3.451 0 01-1.353 2.755 5.948 5.948 0 013.858 5.548.527.527 0 01-.527.523z"
              className="my_teams_tab_svg__prefix__cls-2"
              transform="translate(-28.142 -17.829)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgMyTeamsTab;
